import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";

import Error from "../../components/error";
import SuccessMsg from "../../components/successMsg";
import Button from "../../components/button";
import ICInput from "../../components/form/input";

import { passwordRegex } from "../../constants/constants";

const ChangePasswordFormSchema = Yup.object({
  oldPassword: Yup.string()
    .min(8, "Old password must be of minimum length 8")
    .max(25, "Old password must not be greater than 25 characters")
    .required("Please enter the Old Password"),
  newPassword: Yup.string()
    .required("Please enter New Password")
    .min(8, "Password must be of minimum length 8")
    .matches(
      passwordRegex,
      "Password should be at least 8 and maximum 25 characters long and should contain one number, one special character, one uppercase and one lowercase."
    ),
  confirmNewPassword: Yup.string()
    .required("Please enter Confirm Password")
    .oneOf([Yup.ref("newPassword")], "Both Passwords should match")
});

const ChangePasswordForm = props => {
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: ""
    },
    validationSchema: ChangePasswordFormSchema,
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <h4 className="mb-4">Change Password</h4>
      <div className="form-group row mt-4">
        <label className="col-sm-3 col-form-label pb-0">
          Old Password: <span className="error">*</span>
        </label>
        <div className="col-sm-6">
          <ICInput
            name="oldPassword"
            type="password"
            value={formik.values.oldPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.oldPassword && formik.errors.oldPassword
                ? true
                : false
            }
            helperText={
              formik.touched.oldPassword && formik.errors.oldPassword
                ? formik.errors.oldPassword
                : ""
            }
          />
        </div>
      </div>
      <div className="form-group row mt-4">
        <label className="col-sm-3 col-form-label">
          New Password: <span className="error">*</span>
        </label>
        <div className="col-sm-6">
          <ICInput
            name="newPassword"
            type="password"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.newPassword && formik.errors.newPassword
                ? true
                : false
            }
            helperText={
              formik.touched.newPassword && formik.errors.newPassword
                ? formik.errors.newPassword
                : ""
            }
          />
        </div>
      </div>
      <div className="form-group row mt-4">
        <label className="col-sm-3 col-form-label">
          Confirm New Password: <span className="error">*</span>
        </label>
        <div className="col-sm-6">
          <ICInput
            name="confirmNewPassword"
            type="password"
            value={formik.values.confirmNewPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.confirmNewPassword &&
              formik.errors.confirmNewPassword
                ? true
                : false
            }
            helperText={
              formik.touched.confirmNewPassword &&
              formik.errors.confirmNewPassword
                ? formik.errors.confirmNewPassword
                : ""
            }
          />
        </div>
      </div>
      <br />
      <div className="d-flex flex-row flex-wrap">
        <Button className="mb-4" title="Reset" type="submit" />
      </div>
      <Error>{props.serverErrorMsg}</Error>
      <SuccessMsg>{props.successMsg}</SuccessMsg>
    </form>
  );
};

export default ChangePasswordForm;

ChangePasswordForm.defaultProps = {
  serverErrorMsg: "",
  successMsg: ""
};

ChangePasswordForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  successMsg: PropTypes.string
};
